import React from 'react'
import { useAbValues, useMedia } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { constants } from 'common/helpers'
import { checkAccessToMobileNavExperiment } from 'common/helpers/getters'

import ExceptMobile from './ExceptMobile/ExceptMobile'
import Mobile from './Mobile/Mobile'
import MobileNewHeader from './MobileNewHeader/MobileNewHeader'


const Header = (props) => {
  const { isMobile } = useMedia()
  const mobileNavigationAbValue = useAbValues(constants.abTests.mobileNavigation)
  const { isLoggedIn, registrationDate } = useConnect({
    isLoggedIn: 'models.me.isLoggedIn',
    registrationDate: 'models.me.registrationDate',
  })

  const isMobileLayoutExperimentEnabled = mobileNavigationAbValue === 'b' && checkAccessToMobileNavExperiment({ isMobile, isLoggedIn, registrationDate })

  if (isMobileLayoutExperimentEnabled) {
    return <MobileNewHeader {...props} />
  }

  return React.createElement(isMobile ? Mobile : ExceptMobile, props)
}


export default Header
